import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { WingsApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { addQuery } from "helpers/utis";
import { setLoader } from "./loader";

export const WingsSlice = createSlice({
  name: "Wings",
  initialState: {
    wings: null,
    isLoading: false,
    wingsData: {},
    activeWing: null,
    inactiveWing: null,
  },
  reducers: {
    saveWingsList: (state, action) => {
      state.wings = action.payload || [];
      state.isLoading = false;
    },

    saveWingsData: (state, action) => {
      state.wingsData = action.payload || null;
      state.isLoading = false;
    },

    setSelectedActiveWing: (state, action) => {
      state.activeWing = action.payload;
    },

    setSelectedInactiveWing: (state, action) => {
      state.inactiveWing = action.payload;
    },
  },
});
// same list api, only send type: active / inactive in query
export const getWingsListAct = (query) => (dispatch) => {
  WingsApi.getWingsListApi.addQuery = query;
  addQuery(query || {}, WingsApi.getWingsListApi);

  dispatch(setLoader(true));

  return new Promise((resolve, reject) => {
    api({ ...WingsApi.getWingsListApi })
      .then(({ data }) => {
        dispatch(saveWingsList(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch((err) => {
        if (err?.status === 400) {
          dispatch(saveWingsList(err?.data));
          dispatch(setLoader(false));
          resolve(err?.data);
        } else {
          dispatch(setLoader(false));
          reject(Toast({ type: "error", message: err?.message }));
        }
      });
  });
};

export const getWingsByIdAct = (id) => (dispatch) => {
  dispatch(setLoader(true));

  const baseConfig = WingsApi.getWingsByIdApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        dispatch(saveWingsData(data?.data));
        dispatch(setLoader(false));
        resolve(data?.data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

// add wings
export const createWingsAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...WingsApi.createWingsApi, body })
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Wings added successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// update wings
export const updateWingsAct = (id, body) => () => {
  const baseConfig = WingsApi.updateWingsApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
    body,
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Wings updated successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// active -> inactive OR inactive -> delete based on backend behavior
export const deleteWingsAct = (id) => () => {
  const baseConfig = WingsApi.deleteWingsApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Wings deleted successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// inactive -> active
export const activateWingsAct = (id, status) => () => {
  const baseConfig = WingsApi.changeWingsStatusApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message:
            data?.message ||
            `Wings ${status === "active" ? "activated" : "inactivated"} successfully`,
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveWingsList,
  saveWingsData,
  setSelectedActiveWing,
  setSelectedInactiveWing,
} = WingsSlice.actions;

export default WingsSlice.reducer;
